/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_Sign_InInputs */

const cs_auth_google_sign_in = /** @type {(inputs: Auth_Google_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se přes Google`)
};

const en_auth_google_sign_in = /** @type {(inputs: Auth_Google_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google`)
};

/**
* | output |
* | --- |
* | "Sign in with Google" |
*
* @param {Auth_Google_Sign_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_sign_in = /** @type {((inputs?: Auth_Google_Sign_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_Sign_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_sign_in(inputs)
	return cs_auth_google_sign_in(inputs)
});